<template>
  <el-container style="height:100%; display:block">
    <el-header>
      <img src="../assets/YMTlogo.png" style="float:left" />
      <div style="width: 450px;float: left;margin: 12px;">
        <span style="width: 500px;display: block;color: #488bd2;"
          >一码通产品数字身份管理系统</span
        >
        <span style="width: 500px;display: block;color: #488bd2;"
          >Enterprise Prodcut ID Management System</span
        >
      </div>
      <div class="funmenu">
        <i class="el-icon-user"></i>
        <span>{{ user.username }}</span>
        <i class="el-icon-house"></i>
        <span>首页</span>
        <i class="el-icon-question"></i>
        <span>帮助</span>
        <i class="el-icon-circle-close"></i>
        <el-link
          href=""
          @click="exit"
          type="danger"
          style="line-height: inherit;"
          >退出</el-link
        >
      </div>
    </el-header>
    <el-container style="height:  calc(100% - 60px);width: 100%;">
      <el-aside style="height: 100%;position: fixed;top: 60px" width="none">
        <div width="100%">
          <el-button
            id="menu-vertical"
            :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="openClose()"
          ></el-button>
        </div>
        <el-scrollbar style="height: calc(100% - 120px);position: relative;" width="100%">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#ffffff"
            :collapse="isCollapse"
          >
            <!--
          <el-submenu v-for="(item, index) in menuList" :key="index" :index="index + ''">
            <template slot="title">
              <i  :class="item.IconPT"></i>
              <span onselectstart="return false">{{item.ModuleName}}</span>
            </template>
            <el-menu-item onselectstart="return false" style="padding-left: 60px" v-for="(child, index_) in item.Child" @click="menuClick(child,item)" :key="index_" :index="index + '-' + index_">
              <span>{{child.ModuleName}}</span>
            </el-menu-item>           
          </el-submenu>
          -->
            <el-submenu
              onselectstart="return false"
              v-for="(lev1, index_1) in menuList"
              :key="index_1"
              :index="index_1 + ''"
            >
              <template slot="title">
                <i :class="lev1.IconPT"></i>
                <span>{{ lev1.ModuleName }}</span>
              </template>
              <template v-for="(lev2, index_2) in lev1.Child">
                <el-menu-item
                  v-if="lev2.Child.length == 0"
                  onselectstart="return false"
                  style="padding-left: 60px"
                  @click="menuClick(lev2, lev1)"
                  :key="index_2"
                  :index="index_1 + '-' + index_2"
                >
                  <template slot="title">
                    <i :class="lev2.IconPT"></i>
                    <span>{{ lev2.ModuleName }}</span>
                  </template>
                </el-menu-item>
                <el-submenu
                  v-else-if="lev2.Child.length !== 0"
                  onselectstart="return false"
                  style="padding-left: 20px"
                  :key="index_2"
                  :index="index_1 + '-' + index_2"
                >
                  <template slot="title">
                    <i :class="lev2.IconPT"></i>
                    <span>{{ lev2.ModuleName }}</span>
                  </template>
                  <template v-for="(lev3, index_3) in lev2.Child">
                    <el-menu-item
                      onselectstart="return false"
                      popper-append-to-body="true"
                      style="padding-left: 80px"
                      @click="menuClick(lev3, lev2, lev1)"
                      :key="index_3"
                      :index="index_1 + '-' + index_2 + '-' + index_3"
                    >
                      <template slot="title">
                        <i :class="lev3.IconPT"></i>
                        <span>{{ lev3.ModuleName }}</span>
                      </template>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-main style="transition: margin-left .28s;" :style="{'margin-left': isCollapse ? '69px': '250px'}">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'homepage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-for="(item, index) in breadcrumb"
            :key="index" :to="{name: item.routeName}"
            ref="menu_1"
            ><span >{{ item.listName }}</span></el-breadcrumb-item
          >
        </el-breadcrumb>
        <keep-alive :include="include">
          <router-view />
        </keep-alive>
        <!--
        <div class="bottom" style="text-align: center;">
          <span>@2017-2020</span>
          <span>一码通 版权所有</span>
          <img src="../assets/police.png" style="margin:20px 10px 0 10px"/>
          <span>ICP证：</span>
          <el-link href="http://beian.miit.gov.cn/" type="primary">粤ICP备20007414号</el-link>
        </div>
        -->
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      user: {
        username: "",
        usercode: "",
        cid: ""
      },
      isCollapse: true,
      breadcrumb: [],
      menuList: []
    };
  },
  watch: {
    isCollapse(bool) {
      if (bool) {
        //("#menu-vertical").icon="el-icon-s-unfold";
      } else {
        //("#menu-vertical").icon="el-icon-s-fold";
      }
    }
  },
  computed: {
    include() {
      return ['outListQry']
    }
  },
  created() {
    let breadcrumb = JSON.parse(sessionStorage.getItem("breadcrumb"));
    console.log(breadcrumb)
    this.breadcrumb = breadcrumb;
  },
  methods: {
    go(name){
      console.log(name)
      this.$router.push(name)
    },
    menuClick(data, data2, data3) {
      let arg = arguments.length
      if(arg === 2){
        this.$router.push({ name: data.RouteName });
        let breadcrumb = [];
        breadcrumb.push(
          { listName: data2.ModuleName, routeName: data2.RouteName },
          { listName: data.ModuleName, routeName: data.RouteName }
        );
        sessionStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));
        this.breadcrumb = breadcrumb;
      }else{
        this.$router.push({ name: data.RouteName });
        let breadcrumb = [];
        breadcrumb.push(
          { listName: data3.ModuleName, routeName: data.RouteName },
          { listName: data2.ModuleName, routeName: data2.RouteName },
          { listName: data.ModuleName, routeName: data.RouteName }
        );
        sessionStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));
        this.breadcrumb = breadcrumb;
      }
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    openClose() {
      this.isCollapse = !this.isCollapse;
    },
    exit() {
      sessionStorage.clear();
    },
    getModules(usercode) {
      this.$axios({
        method: "post",
        url: "/FW/RoleAssign.ashx",
        params: {
          action: "GetPageModuleTable",
          UserId: usercode
        }
      }).then(res => {
        if (res.Code == 0) {
          console.log(res);
          this.menuList = res.Data;
        } else {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "warning"
          });
        }
      });
    }
  },
  mounted: function() {
    var user = JSON.parse(sessionStorage.getItem("user"));
    this.user.username = user.Username;
    this.getModules(user.Usercode);
  }
};
</script>

<style scoped>
.el-header {
  padding: 0;
  background: url(../assets/top_bg.png);
}
.el-header img {
  height: 40px;
  margin: 10px 0 0 15px;
}
.funmenu {
  margin: 0 13px 0 0;
  float: right;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
}
.el-header div i {
  width: 30px;
  height: 30px;
  margin: 20px 0;
}
.el-header div lable {
  width: 30px;
  height: 30px;
  font-size: 15px;
}
.el-button {
  border: 0px;
  font-size: 25px;
}
.el-button:focus {
  background-color: #ffffff;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
  min-height: 90px;
}
/* .el-menu {
  width: 70px;
  height: calc(100vh - 120px);
  border-right: solid 0px;
  overflow-y: auto;
} */

.el-submenu .el-menu-item {
  min-width: 0px;
  padding-left: 50px;
}
.el-breadcrumb {
  margin: 20px 0 0 0;
}
.el-main {
  background: url(../assets/mainBG.png) no-repeat left bottom;
  background-size: 100%, auto;
  height: 690px;
}

.el-menu{
	border: 0;
}
.el-menu--popup .el-submenu{
  padding-left: 40px !important;
}
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}
.el-table th.gutter {
  display: table-cell !important;
}
</style>
<style>
.el-dialog__body {
  padding: 0px 20px;
}
.el-input__icon {
  width: auto;
  line-height: 42px;
}
h3 {
  line-height: 40px !important;
  margin: 20px 0 5px 0 !important;
  padding-left: 10px !important;
  background: #f8f8f8 !important;
  font-size: 1.17em !important;
}
.item {
  margin: 0 0 20px 0;
  padding: 20px;
  background: #f8f8f8;
}
.el-popup-parent--hidden {
  padding-right: 0 !important;
}

</style>


// WEBPACK FOOTER //
// src/main/main.vue